import { createRouter, createWebHistory } from 'vue-router'
import { routes } from '@/router/routes'

export default function () {
  const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: routes(),
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      } else {
        return { top: 0 }
      }
    },
  })

  return router
}
